import { render, staticRenderFns } from "./buildingFormList.vue?vue&type=template&id=2fbb3a51&scoped=true"
import script from "./buildingFormList.vue?vue&type=script&lang=js"
export * from "./buildingFormList.vue?vue&type=script&lang=js"
import style0 from "./buildingFormList.vue?vue&type=style&index=0&id=2fbb3a51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbb3a51",
  null
  
)

export default component.exports